const hasCustomFavicon = () => !!window.chatwootConfig?.customFavicon;

const supportsAppBadge = () =>
  typeof navigator !== 'undefined' && 'setAppBadge' in navigator;

// PWA App Badge (Badging API): shows an unread dot on the *installed* app icon
// (desktop/Android PWA), independent of the browser-tab favicon — so it works
// even when a custom favicon hides the favicon badge variants. Promises are
// swallowed: an unsupported/denied badge must never break the alert flow.
export const setPwaUnreadBadge = () => {
  if (!supportsAppBadge()) return;
  navigator.setAppBadge().catch(() => {});
};

export const clearPwaUnreadBadge = () => {
  if (!supportsAppBadge()) return;
  navigator.clearAppBadge().catch(() => {});
};

export const showBadgeOnFavicon = () => {
  // Set the PWA app badge regardless of custom favicon (independent surface).
  setPwaUnreadBadge();

  if (hasCustomFavicon()) return; // Custom favicons don't have badge variants

  const favicons = document.querySelectorAll('.favicon');
  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;

    // Coming back to the app clears the unread state on both surfaces.
    clearPwaUnreadBadge();

    if (hasCustomFavicon()) return; // Custom favicons don't need the switcher

    const favicons = document.querySelectorAll('.favicon');
    favicons.forEach(favicon => {
      const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
      favicon.href = oldFileName;
    });
  });
};
